import {
	buildExternal,
	scrollPageTo,
	getParameterByName,
	showSearchModal,
	validateCssSelector,
} from "./modules/utilities.js";
import svgToInline from "./modules/svgToInline.js";
import marketo from "./modules/marketo.js";
import { menuInit } from "./modules/menu.js";
import mainNav from "./components/showMainNav.js";
import stopTransitions from "./components/stopTransitions.js";
import Menubar from "./components/menuKeyboardSupport.js";
import { debounce } from "./modules/utilities";

mainNav("js-open-menu", "js-close-menu", "js-overlay");
stopTransitions();

if (window.innerWidth > 984) {
	var menubar = new Menubar(document.getElementById("js-main-menu"), 984);
	menubar.init();
}

const resize = debounce(function () {
	if (window.innerWidth > 984) {
		var menubar = new Menubar(document.getElementById("js-main-menu"), 984);
		menubar.init();
		return;
	}
	let oldMenu = document.getElementById("js-main-menu");

	let elem = oldMenu.firstElementChild;

	while (elem) {
		let menuElement = elem.firstElementChild;

		if (
			menuElement &&
			menuElement &&
			(menuElement.tagName === "A" || menuElement.tagName === "BUTTON")
		) {
			menuElement.tabIndex = -1;
			menuElement.setAttribute("aria-haspopup", false);
			let dropdownMenu = menuElement.nextElementSibling;

			if (dropdownMenu && dropdownMenu.tagName === "UL") {
				let listItem = dropdownMenu.firstElementChild;

				while (listItem) {
					let link = listItem.firstElementChild;
					link.tabIndex = 1;

					listItem = listItem.nextElementSibling;
				}
			}
		}

		elem = elem.nextElementSibling;
	}
	let newMenu = oldMenu.cloneNode(true);

	oldMenu.parentNode.replaceChild(newMenu, oldMenu);
});

window.addEventListener("resize", resize);

$(function () {
	var $ = jQuery;

	var ABLE = {
		ui: function () {
			svgToInline("img.js-svg");
			menuInit(".menu-toggle");

			// OPEN .PDF'S AND EXTERNAL LINKS IN A NEW WINDOW
			// Add warning of leaving site
			buildExternal();

			//Search Modal
			showSearchModal(".js-search-btn");

			// ICHECK
			if ($(".js-radio-check input").length > 0) {
				$(".js-radio-check input").iCheck({
					checkboxClass: "icheckbox_minimal-grey",
					radioClass: "iradio_minimal-grey",
				});
			}

			// AFTER CSS IS LOADED
			window.addEventListener("load", function () {
				let urlHash = window.location.hash ? window.location.hash : false;

				if (urlHash !== false) {
					//Scroll to id in URL
					scrollPageTo(urlHash);

					let linkID = urlHash.substring(1);
					if ($("#tab-" + linkID).length) {
						$("#tab-" + linkID).click();
					} else if ($("#content-area").length) {
						scrollPageTo("#content-area");
					}
				}

				//re-rerun matchheight
				$.fn.matchHeight._update();
			});
		},

		init: function () {
			ABLE.ui();
		},
	};

	ABLE.init();

	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not(".js-no-scroll")
		.click(function (e) {
			// On-page links
			if (
				location.pathname.replace(/^\//, "") ==
					this.pathname.replace(/^\//, "") &&
				location.hostname == this.hostname
			) {
				e.preventDefault();
				scrollPageTo(this.hash);
			}
		});

	// Adding rel="noopener noreferrer" to all links that have target="_blank"
	const links = document.querySelectorAll('a[target="_blank"]');

	for (let i = 0; i < links.length; i++) {
		const link = links[i];

		link.setAttribute("rel", "noopener noreferrer");
	}
});

// If parameters is set to success will scroll to and display success message
const r = getParameterByName("r");
const i = getParameterByName("i");

if (r == "success") {
	let messageId = "#js-success-scroll";

	if (typeof i !== "undefined" && i !== null) {
		messageId = "#" + i;
	}

	$(messageId).show(function () {
		let successBox = $(messageId).offset().top - 130;
		$("html, body").animate(
			{
				scrollTop: successBox,
			},
			300
		);
	});
}

if (typeof MktoForms2 !== "undefined") {
	marketo(".js-marketo-form");
}
